import { useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';

// Import Pages and other components
import Home from './pages/Home';
import CreateGame from './pages/CreateGame';
import JoinGame from './pages/JoinGame';
import Lobby from './pages/Lobby';
import Game from './pages/Game';
import Results from './pages/Results';
import NotFound from './pages/NotFound';
import { useGameSync } from './hooks/useGameSync';
import { useGameStore } from './stores/gameStore';
import TopBar from './components/TopBar';
import TopBarLanguageSelector from './components/TopBarLanguageSelector';
import { ReconnectingOverlay } from './components/ReconnectingOverlay';

// Component to run the sync hook
const GameSyncRunner = () => {
	useGameSync();

	return null;
};

function AppContent() {
	const navigate = useNavigate();
	const navigationTarget = useGameStore((state) => state.navigationTarget);
	const clearNavigationTarget = useGameStore((state) => state.clearNavigationTarget);

	// --- Navigation Effect ---
	useEffect(() => {
		if (navigationTarget) {
			navigate(navigationTarget);
			clearNavigationTarget();
		}
	}, [navigationTarget, navigate, clearNavigationTarget]);

	// --- Render UI and Routes ---
	return (
		<div className='App min-h-screen'>
			<ReconnectingOverlay />
			<GameSyncRunner /> {/* Initialize socket listeners */}
			<TopBar>
				<TopBarLanguageSelector />
			</TopBar>
			<Routes>
				<Route path='/' element={<Home />} />
				<Route path='/create' element={<CreateGame />} />
				<Route path='/join' element={<JoinGame />} />
				<Route path='/lobby/:gameId' element={<Lobby />} />
				<Route path='/game/:gameId' element={<Game />} />
				<Route path='/results/:gameId' element={<Results />} />
				<Route path='/404' element={<NotFound />} />
				<Route path='*' element={<Navigate to='/404' replace />} />
			</Routes>
		</div>
	);
}

export default AppContent;
